import { render } from "./Latestpackages.vue?vue&type=template&id=4ac4f72a"
import script from "./Latestpackages.vue?vue&type=script&lang=js"
export * from "./Latestpackages.vue?vue&type=script&lang=js"

import "./Latestpackages.vue?vue&type=style&index=0&id=4ac4f72a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__